import React from 'react';
import {
  FormControl,
  FormLabel,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

export const BasicSettings = ({ 
  name, qwantumId, selectName, placeholder, cssClass, selectClass, setProp 
}) => (
  <Accordion defaultExpanded>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Typography variant="subtitle2">Basic Properties</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <FormControl fullWidth margin="normal">
        <FormLabel>Component Name</FormLabel>
        <TextField
          value={name || ''}
          onChange={(e) => setProp(props => props.name = e.target.value)}
          size="small"
          placeholder="Enter component name"
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Select Name</FormLabel>
        <TextField
          value={selectName || ''}
          onChange={(e) => setProp(props => props.selectName = e.target.value)}
          size="small"
          placeholder="Enter select name attribute"
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Quantum ID</FormLabel>
        <TextField
          value={qwantumId || ''}
          onChange={(e) => setProp(props => props.qwantumId = e.target.value)}
          size="small"
          placeholder="Enter quantum ID for persistence"
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Placeholder</FormLabel>
        <TextField
          value={placeholder || ''}
          onChange={(e) => setProp(props => props.placeholder = e.target.value)}
          size="small"
          placeholder="Enter placeholder text"
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>CSS Class (Container)</FormLabel>
        <TextField
          value={cssClass || ''}
          onChange={(e) => setProp(props => props.cssClass = e.target.value)}
          size="small"
          placeholder="Enter CSS class names for container"
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>CSS Class (Select)</FormLabel>
        <TextField
          value={selectClass || ''}
          onChange={(e) => setProp(props => props.selectClass = e.target.value)}
          size="small"
          placeholder="Enter CSS class names for select control"
        />
      </FormControl>
    </AccordionDetails>
  </Accordion>
);